import React from "react"
import { useHistory } from "react-router-dom" //, Link as RouterLink
import { useSnackbar } from "notistack"
import { useSetRecoilState } from "recoil"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import Grid from "@material-ui/core/Grid"
// import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import Button from "../components/Button"
import PasswordField from "../components/PasswordField"
import TextField from "../components/TextField"
import { logIn } from "../libs/manageAccounts"
// import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"

// We need to adjust the signup to store more information.
// Likely the dbUser creation needs to happen with the Cognito, so we can have the association available.
// Especially for invites.
//
// When logging in, if not confirmed, redirect to confirmation form
// Add "resend code" link to confirmation form
//
// During sign up, if email exists, just go back to notification it exists
//
// During sign up, if association already exists, ask if they want to join existing.
// This will rely on when the process has more information (eg: address).
//
// Add confirmation code link support (this solves a lot of problem with getting back to confirmation)
//  - adjust confirmation email content to include url
//  - test for code in url and submit it if exists, otherwise default form

export default function Signin() {
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const setUser = useSetRecoilState(currentUser)

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string().email().required("Valid email required"),
        password: Yup.string()
          .required("Password required")
          .matches(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
            "Must be minimum 8 characters, 1 uppercase, 1 lowercase, 1 number, and 1 special character"
          ),
      })}
      onSubmit={async (values) => {
        try {
          const loggedInUser = await logIn(values.email, values.password)
          if (loggedInUser) {
            setUser(loggedInUser)
            enqueueSnackbar("Welcome back!")
            history.push("/0")
          } else {
            throw new Error("There was a problem signing in")
          }
        } catch (error) {
          console.log("error", error)
          if (error.message === "User is not confirmed.") {
          }
          enqueueSnackbar(
            "Wrong email or password. Try again or click Forgot password to reset it.",
            {
              variant: "error",
            }
          )
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        isValid,
        touched,
        values,
        setFieldValue,
      }) => {
        return (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  label="Email"
                  name="email"
                />
              </Grid>
              <Grid item xs={12}>
                <PasswordField
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  label="Password"
                  name="password"
                />
              </Grid>
              <Grid container item xs={6} justifycontent="flex-end">
                <Button isLoading={isSubmitting} size="small" type="submit">
                  Sign In
                </Button>
              </Grid>
              {/* <Grid item style={{ textAlign: "right" }} xs={6}>
                <Button
                  color="primary"
                  component={RouterLink}
                  onClick={() => {}}
                  size="small"
                  to="/signin/confirm"
                  variant="text"
                >
                  Confirm Your Email
                </Button>
              </Grid> */}
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}
